// Información de build generada automáticamente
export const BUILD_DATE = '22-07-2026 19:52:33';
export const BUILD_HASH = '7i7lp2utjhb';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1784760753237;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '22-07-2026 19:52:33',
  buildHash: '7i7lp2utjhb',
  appVersion: '0.0.0',
  timestamp: 1784760753237
});
